<template>
    <div class="loading">
      <CSpinner class="load_spinner"/>
    </div>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<style>
  .loading {
    z-index: 9999;
    position: fixed;
    margin: auto;
    width: 95%;
    height: 95%;
    background-color: #EBEDEF;
    opacity:  0.5;
  }
  .load_spinner {
    position: absolute;
    left: 40%;
    top: 20%;
  }
</style>
